import { render, staticRenderFns } from "./ui-dialog.vue?vue&type=template&id=dc9278a0"
import script from "./ui-dialog.vue?vue&type=script&lang=js"
export * from "./ui-dialog.vue?vue&type=script&lang=js"
import style0 from "./ui-dialog.vue?vue&type=style&index=0&id=dc9278a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports